/* eslint-disable @next/next/no-img-element */
import classes from '@src/styles/SustainabilityData.module.css'
import Image from 'next/image'
import sustainabilityData from '@src/assets/sustainability/sustainabilityData.jpg'
import feature1 from '@src/assets/sustainability/feature-1.svg'
import feature2 from '@src/assets/sustainability/feature-2.svg'
import feature3 from '@src/assets/sustainability/feature-3.svg'
import Link from 'next/link'
import { useRouter } from 'next/router'

function SustainabilityData() {
  const router = useRouter();
  const { gclid, keyword, location } = router.query;
  return (
    <section className={classes.container}>
      <div className={classes.mainContent}>
        <img alt='' className={classes.image} src={sustainabilityData.src} />
        <div className={classes.featureContainer}>
          <h2 className={classes.header}>Revolutionary Diversion Data</h2>
          <div className={classes.feature}>
            <Image src={feature1} alt='' />
            <div className={classes.featureContent}>
              <h4 className={classes.featureHeader}>Total Transparency</h4>
              <p className={classes.featureDescription}>
                Dimension offers crystal clear visibility on every pickup, making it simple for you
                to check where your waste ended up.
              </p>
            </div>
          </div>
          <div className={classes.feature}>
            <Image src={feature2} alt='' />
            <div className={classes.featureContent}>
              <h4 className={classes.featureHeader}>Precise Breakdowns</h4>
              <p className={classes.featureDescription}>
                Easily track the total weight and composition of every pickup with our detailed
                waste stream stats.
              </p>
            </div>
          </div>
          <div className={classes.feature}>
            <Image src={feature3} alt='' />
            <div className={classes.featureContent}>
              <h4 className={classes.featureHeader}>Consolidated Data</h4>
              <p className={classes.featureDescription}>
                Access data about all of your pickups in one clean, intuitive interface.
              </p>
            </div>
          </div>
          <Link href={`${process.env.NEXT_PUBLIC_REDIRECT_URL}booking?step=initial&gclid=${gclid ?? ""}&keyword=${keyword ?? ""}&redirect=1&location=${location ?? ""}`} className={classes.primaryButton}>
            Book Now
          </Link>
        </div>
      </div>
    </section>
  )
}

export default SustainabilityData
